import styled from '../styled-components';

const Layout = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -1rem;
    & > * {
        margin: 1rem;
        flex: 100 1 30rem;
    }
`;

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.tsx